import mockMusicLinkUrlPartsData from "../data/mockData/musicLinkUrlPartsData";
import {
  getActiveDemoMusicLinkUrlPartSeedRows,
  getDemoMusicLinkUrlPartRows,
} from "./demoMusicLinkUrlPartsSessionStore";
import { getMusicLinkRows } from "./musicLinkDemoHelpers";

function mergeById(baseRows, extraRows) {
  const map = new Map();
  (baseRows || []).forEach(row => {
    if (row && row.id != null) {
      map.set(String(row.id), row);
    }
  });
  (extraRows || []).forEach(row => {
    if (row && row.id != null) {
      map.set(String(row.id), { ...(map.get(String(row.id)) || {}), ...row });
    }
  });
  return Array.from(map.values());
}

export function enrichMusicLinkUrlPartRow(row) {
  if (!row) {
    return row;
  }
  const inUse = getMusicLinkRows().some(
    link => String(link.url_part1) === String(row.id),
  );
  return {
    ...row,
    can_be_deleted: inUse ? false : row.can_be_deleted !== false,
  };
}

export function getMusicLinkUrlPartRows() {
  return mergeById(
    getActiveDemoMusicLinkUrlPartSeedRows(mockMusicLinkUrlPartsData),
    getDemoMusicLinkUrlPartRows(),
  ).map(enrichMusicLinkUrlPartRow);
}

export function getMusicLinkUrlPartById(id) {
  const row = getMusicLinkUrlPartRows().find(item => String(item.id) === String(id));
  return row ? enrichMusicLinkUrlPartRow(row) : { detail: "Not found." };
}

export function isMusicLinkUrlPartNameTaken(part, excludeId) {
  const normalized = String(part || "").trim().toLowerCase();
  if (!normalized) {
    return false;
  }
  return getMusicLinkUrlPartRows().some(row => {
    if (excludeId != null && String(row.id) === String(excludeId)) {
      return false;
    }
    return String(row.part || "").trim().toLowerCase() === normalized;
  });
}

export function validateMusicLinkUrlParts(urlPart1, urlPart2, excludeMusicLinkId) {
  const part2 = String(urlPart2 || "").trim();
  if (!part2) {
    return { valid: true, status: "Url is available" };
  }
  const taken = getMusicLinkRows().some(row => {
    if (excludeMusicLinkId != null && String(row.id) === String(excludeMusicLinkId)) {
      return false;
    }
    return (
      String(row.url_part1) === String(urlPart1) &&
      String(row.url_part2 || "").trim().toLowerCase() === part2.toLowerCase()
    );
  });
  return {
    valid: !taken,
    status: taken
      ? "Oops! This url is already associated with another music link. Please try another url."
      : "Url is available",
  };
}

export function filterMusicLinkUrlPartRows(rows, rawQuery) {
  const queryText = String(rawQuery || "").trim().toLowerCase();
  if (!queryText) {
    return rows;
  }
  return (rows || []).filter(row =>
    [row?.part, row?.owner].some(value => String(value || "").toLowerCase().includes(queryText)),
  );
}

export function selectMergedMusicLinkUrlParts(state) {
  const slice = state?.musicLinks;
  if (Array.isArray(slice)) {
    return slice;
  }
  const created = slice?.created || [];
  return getMusicLinkUrlPartRows().length
    ? mergeById(getMusicLinkUrlPartRows(), created).map(enrichMusicLinkUrlPartRow)
    : getMusicLinkUrlPartRows();
}

export function buildMusicLinkUrlPartRowFromPayload(body, id) {
  const payload = body || {};
  return enrichMusicLinkUrlPartRow({
    id: Number(id) || id,
    part: String(payload.part || "").trim(),
    owner: payload.owner || "John Doe",
    can_be_deleted: true,
  });
}
